// extracted by mini-css-extract-plugin
export default {"posicion":"TablaTorneoParticipantes_posicion__VNO6X","equipo":"TablaTorneoParticipantes_equipo__c4pKM","observaciones":"TablaTorneoParticipantes_observaciones__ClFH1"};